import styled, { css } from 'styled-components';

import { Modal } from '@pkg/components/Modal';

const PODS_ICON_HEIGHT = 60;

type InputWrapperProps = {
    $charactersLeft: number;
};

export const InputWrapper = styled.div<InputWrapperProps>`
    width: 100%;

    // TODO: All of these overrides need to be removed.

    .yat-standard-input__remaining {
        opacity: 0.5;

        ${({ $charactersLeft }) =>
            $charactersLeft > 3 &&
            css`
                color: white;
            `}
    }

    .yat-standard-input__fake-input {
        svg {
            height: 20px;
            opacity: 0.5;

            @media (min-width: ${(props) => props.theme.breakpoints.tabletSmall}) {
                height: 25px;
            }
        }
    }

    .yat-standard-input__error-label {
        width: 90%;
    }

    .yat-standard-input__input-and-label {
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }

    .yat-standard-input--focused {
        input {
            height: 60px;
            padding-top: 15px;
            font-size: 20px;
        }

        .yat-standard-input__label {
            transform: translateY(-10%) scale(0.75);

            @media (min-width: ${(props) => props.theme.breakpoints.tabletSmall}) {
                transform: translateY(10%) scale(0.75);
            }
        }
    }

    input {
        margin: 0;
        padding: 0;
    }

    svg {
        fill: white;
    }
`;

export const ModalLayout = styled(Modal.Layout)`
    padding: 90px 25px 50px 25px;
    gap: 16px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 80px 100px 80px 100px;
    }
`;

export const Heading = styled.div`
    font-weight: 700;
    font-size: 30px;
    line-height: 105%;
    text-align: center;
    letter-spacing: -0.04em;
    margin-top: 20px;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin-top: 6px;

        font-size: 40px;
        line-height: 85%;
    }
`;

export const Subheading = styled.div`
    font-weight: 500;
    font-size: 16px;
    line-height: 120%;
    text-align: center;
    letter-spacing: -0.03em;
    margin-top: 10px;
    opacity: 0.5;

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        margin-top: 20px;
    }
`;

export const IconWrapper = styled.div`
    margin-right: 10px;
    width: 20px;
    opacity: 0.5;
`;

export const PodsIconContainer = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    align-content: center;
    margin-top: 30px;
    margin-bottom: 10px;
    height: ${PODS_ICON_HEIGHT}px;
`;

export const PodsIconWrapper = styled.div`
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
`;

export const SectionWrapper = styled.div`
    display: grid;
    align-content: baseline;
    justify-items: center;
    gap: 10px;
`;

export const ButtonWrapper = styled.div`
    && {
        button {
            width: 100% !important;
        }
    }
`;
